/*
 * @Date: 2022-12-27 10:40:33
 * @LastEditors: Leo
 * @LastEditTime: 2022-12-27 10:42:38
 * @FilePath: \3.0-manger\src\js\components\details-disclosure.js
 * @description: drop-menu
 */

import "./index.less"
export default class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

      // 向外抛出自定义事件
      this.mainDetailsToggle.addEventListener("toggle", (event) => {
        if (this.mainDetailsToggle.open) {
          this.handleOpen?.()
          // const event_details_open = new CustomEvent('detailsOpenEvent', {
          //   detail: {
          //     detailsDOM: this.mainDetailsToggle,
          //     summaryDOM: this.mainDetailsToggle.querySelector('summary'),
          //   }
          // });
          // document.dispatchEvent(event_details_open);
        } else {
          this.handleClose?.()
          // const event_details_close = new CustomEvent('detailsCloseEvent', {
          //   detail: {
          //     detailsDOM: this.mainDetailsToggle,
          //     summaryDOM: this.mainDetailsToggle.querySelector('summary'),
          //   }
          // });
          // document.dispatchEvent(event_details_close);
        }
      });
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      })
    }
  
    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }
  
  // customElements.define('details-disclosure', DetailsDisclosure);
  